import * as React from 'react';

import { IParticipation } from '../../types/agents';
import { Participation } from '../Participation';

import * as styles from './ParticipationList.css';

type TProps = {
  participations?: IParticipation[] | null;
};

export const ParticipationList: React.FC<TProps> = ({ participations }) => {
  if (!participations?.length) {
    return null;
  }

  return (
    <div className={styles['list']} data-name="ParticipationList">
      {participations.map(participation => (
        <Participation key={participation.type} participation={participation} />
      ))}
    </div>
  );
};
